import { useProduct, ProductProvider } from "@workspace/utils-react";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import type { JSX } from "react/jsx-runtime";
import AppContainerFromstock from "../../stock/src/components/AppContainer";
import { ModeProvider } from "@/providers/ModeProvider";
import { AuthBridgeProvider } from "./providers/AuthBridgeProvider";
import type { PidgetSettings } from "./helpers/PidgetSettings";
import LoginCallback from "./LoginCallback";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const AppContainer = (): React.ReactElement => {
  const queryClient = new QueryClient();
  const product = useProduct<PidgetSettings>();

  if (product?.settings?.identityUrl) {
    return (
      <QueryClientProvider client={queryClient}>
        <ProductProvider iframePidget={product}>
          <AuthProvider
            client_id={product.settings.clientId}
            redirect_uri={window.location.origin}
            silent_redirect_uri={`${window.location.origin}/login/callback`}
            scope={product.settings.scope}
            authority={product.settings.identityUrl}
          >
            <AuthBridgeProvider instanceId={product.instanceId}>
              <ModeProvider>
                <AppContainerFromstock settings={product.settings} />
              </ModeProvider>
            </AuthBridgeProvider>
          </AuthProvider>
        </ProductProvider>
      </QueryClientProvider>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login/callback" element={<LoginCallback />} />
      </Routes>
    </BrowserRouter>
  );
};
